import React from "react";
import { lightIcon } from "./LightIcon.scss";

/** Icon names that need to be changed to match the expected "Light" variation name */
const iconNameCorrections: {
    [iconName: string]: string;
} = {
    ArrowDownFilled: "ArrowDownRegular",
    BorderAllRegular: "TableSimpleRegular",
    MailArrowDoubleBackFilled: "MailArrowDoubleBackRegular",
    MicFilled: "MicRegular",
    TextTRegular: "TextRegular",
};

export interface LightIconProps {
    iconName: string;
}
export const LightIcon = ({ iconName }: LightIconProps): React.JSX.Element => {
    return <i className={`${lightIcon} lightIcon--${iconNameCorrections[iconName] || iconName}`}/>;
};
